var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from 'react';
import Cookies from 'js-cookie';
import { Container, Div } from './styles';
import { HomeIcon, MaintenanceIcon, DocumentsIcon, PersonIcon, LogoutIcon, TicketIcon, } from '../../assets/Images';
import { HOME, DOCUMENTS, MAINTENANCE, ACCOUNT_TEXT, LOGIN_TEXT, APARTMENTS, ASSEMBLIES_MINUTES, COLLECTION_MANAGEMENT, COMMON_EXPENSES_RECEIPTS, CONTACTS, ONLINE_COLLECTION, BILLS, BUILDINGS, MESSAGES, PAYMENT_HISTORY, SETTELMENTS, PROVIDERS, ADMINS, ACCOUNT, ASSEMBLIES_SUMMONS_TITLE, } from 'src/Utils';
import { MenuComponent } from 'src/Components';
import { TYPE_CONTACT, OTHER_DOCUMENTS, ROUTES, SISTARBANC, HOME_ADMIN_TEXT, TYPE_ADMIN, RESERVATIONS, BOOKING_BLOCKED_DATES, TICKETS, TICKETS_LIST, TICKET_ALERTS, PROVIDER_ARRANGEMENTS, TICKET_REMINDERS, } from 'src/Utils/constants';
var minutes = ROUTES.minutes, settlement = ROUTES.settlement, bill = ROUTES.bill, summons = ROUTES.summons, payment = ROUTES.payment, receipt = ROUTES.receipt, otherDocuments = ROUTES.otherDocuments, apartments = ROUTES.apartments, buildings = ROUTES.buildings, contacts = ROUTES.contacts, messages = ROUTES.messages, admins = ROUTES.admins, providers = ROUTES.providers, collection_manager = ROUTES.collection_manager, sistarbanc = ROUTES.sistarbanc, reservations = ROUTES.reservations, booking_blocked_dates = ROUTES.booking_blocked_dates, tickets = ROUTES.tickets, alertas_tickets = ROUTES.alertas_tickets, gestiones_con_proveedores = ROUTES.gestiones_con_proveedores, ticket_reminders = ROUTES.ticket_reminders, client_tickets = ROUTES.client_tickets;
var bottomItems = [
    { text: '', key: ROUTES.account, icon: PersonIcon },
    { text: '', key: LOGIN_TEXT, icon: LogoutIcon },
];
var AdminLayout = function (_a) {
    var children = _a.children;
    var isContact = Cookies.get('User') === TYPE_CONTACT;
    var isAdmin = Cookies.get('User') === TYPE_ADMIN;
    var isSuperAdmin = Cookies.get('SuperAdmin') === 'true';
    var topItems = ([
        { text: HOME, key: ROUTES.dashboard, icon: HomeIcon },
        {
            text: DOCUMENTS,
            key: '',
            icon: DocumentsIcon,
            options: [
                { name: ASSEMBLIES_MINUTES, key: minutes },
                { name: ASSEMBLIES_SUMMONS_TITLE, key: summons },
                { name: BILLS, key: bill },
                { name: PAYMENT_HISTORY, key: payment },
                { name: SETTELMENTS, key: settlement },
                { name: COMMON_EXPENSES_RECEIPTS, key: receipt },
                { name: OTHER_DOCUMENTS, key: otherDocuments },
            ],
        },
        {
            text: MAINTENANCE,
            key: '',
            icon: MaintenanceIcon,
            options: isSuperAdmin
                ? [
                    { name: APARTMENTS, key: apartments },
                    { name: ADMINS, key: admins },
                    { name: ONLINE_COLLECTION, key: '' },
                    { name: CONTACTS, key: contacts },
                    { name: BUILDINGS, key: buildings },
                    { name: RESERVATIONS, key: reservations },
                    { name: MESSAGES, key: messages },
                    { name: PROVIDERS, key: providers },
                    { name: SISTARBANC, key: sistarbanc },
                    { name: BOOKING_BLOCKED_DATES, key: booking_blocked_dates },
                ]
                : [
                    { name: APARTMENTS, key: apartments },
                    { name: ONLINE_COLLECTION, key: '' },
                    { name: CONTACTS, key: contacts },
                    { name: BUILDINGS, key: buildings },
                    { name: RESERVATIONS, key: reservations },
                    { name: MESSAGES, key: messages },
                    { name: BOOKING_BLOCKED_DATES, key: booking_blocked_dates },
                    { name: PROVIDERS, key: providers },
                ],
            subOptions: [{ name: COLLECTION_MANAGEMENT, key: collection_manager }],
        },
        {
            text: TICKETS,
            key: '',
            options: [
                {
                    name: TICKETS_LIST,
                    key: tickets,
                },
                {
                    name: TICKET_ALERTS,
                    key: alertas_tickets,
                },
                {
                    name: PROVIDER_ARRANGEMENTS,
                    key: gestiones_con_proveedores,
                },
                {
                    name: TICKET_REMINDERS,
                    key: ticket_reminders,
                }
            ],
            icon: TicketIcon,
        },
        { text: TYPE_ADMIN, key: HOME_ADMIN_TEXT, icon: HomeIcon },
        { text: ACCOUNT, key: ACCOUNT_TEXT, icon: PersonIcon },
    ]);
    var getTopItems = function () {
        if (isContact)
            return __spreadArrays(topItems.filter(function (item) { return item.text !== MAINTENANCE && item.text !== TYPE_ADMIN && item.text !== TICKETS; }), [
                {
                    text: 'Reclamos',
                    key: client_tickets,
                    icon: TicketIcon,
                },
            ]);
        else if (isAdmin && !isSuperAdmin)
            return topItems.filter(function (item) { return item.text !== TYPE_ADMIN; });
        else
            return topItems;
    };
    return (React.createElement(Container, null,
        React.createElement(MenuComponent, { topItems: getTopItems(), bottomItems: bottomItems, showNotifications: isAdmin && !isContact, className: isContact ? 'smaller' : '' }),
        React.createElement(Div, null, children)));
};
export default AdminLayout;
